// Weather modifier storage. Choice persists in localStorage and is read on
// each new run by PlayPage (2D) and Play3DPage. Weather is a Pro/Season perk.

const KEY = "ppe_weather_v1";

// Supported types (null / off = clear)
export const WEATHER_TYPES = ["off", "rain", "fog", "wind"];

export function getWeather() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { type: "off", intensity: 0.6 };
    const parsed = JSON.parse(raw);
    if (!WEATHER_TYPES.includes(parsed.type)) return { type: "off", intensity: 0.6 };
    return { type: parsed.type, intensity: Math.max(0.2, Math.min(1, parsed.intensity || 0.6)) };
  } catch {
    return { type: "off", intensity: 0.6 };
  }
}

export function setWeather({ type, intensity }) {
  const clean = {
    type: WEATHER_TYPES.includes(type) ? type : "off",
    intensity: Math.max(0.2, Math.min(1, intensity ?? 0.6)),
  };
  localStorage.setItem(KEY, JSON.stringify(clean));
  return clean;
}

// Convert the stored weather to a runtime "weather" prop suitable for
// createGameState. Returns null when off.
export function weatherForRun() {
  const w = getWeather();
  if (w.type === "off") return null;
  return w;
}

export const WEATHER_LABELS = {
  off: "CLEAR",
  rain: "RAIN",
  fog: "FOG",
  wind: "WIND",
};
